export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
        noticeDeliveryInfo: {
            noticeDeliveryAt: 1234567890123,
            serviceName: "xxxxxx",
            deliveryTo: ["xxxxx","xxxxxx"],
            deliveryStatus: 1,
            deliveryLocationCount: 141,
            openedLocatonCount: 41,
            thumbupLocationCount: 39,
            deliverySpCount: 1200,
            openedSpCount: 722,
            thumbupSpCount: 697
        },
        deliveryContents: {}
    }
  }
}